import { Box, Flex, Text } from '@chakra-ui/react';
import { TransactionListLabels } from '../../../types/transactions';
import { useMediaQuery } from 'react-responsive';
import { SCREEN_SM } from 'utils/constants';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

interface SortConfig {
  key: string;
  direction: 'asc' | 'desc';
}

interface OwnProps {
  onSort?: (key: string) => void;
  sortConfig?: SortConfig;
}

const TransactionListHeader = ({ onSort, sortConfig }: OwnProps) => {
  const isScreenSmall = useMediaQuery({ query: `(max-width: ${SCREEN_SM})` });

  const renderSortIcon = (key: string) => {
    if (sortConfig?.key !== key) {
      return <Box as="span" ml={1} color="blackAlpha.300" display="inline-block">{FaSort({})}</Box>;
    }
    return sortConfig.direction === 'asc' ?
      <Box as="span" ml={1} color="blackAlpha.700" display="inline-block">{FaSortUp({})}</Box> :
      <Box as="span" ml={1} color="blackAlpha.700" display="inline-block">{FaSortDown({})}</Box>;
  };

  const sortableStyle = {
    cursor: 'pointer',
    userSelect: 'none' as const,
    display: 'flex',
    alignItems: 'center',
    _hover: { opacity: 0.8 },
  };

  return (
    <Flex
      width="full"
      alignItems="center"
      h={10}
      px={4}
      mt={isScreenSmall ? 2 : 6}
      bg="primary"
      borderTopRadius={isScreenSmall ? 0 : 8}
    >
      {/* Type icon spacer */}
      {!isScreenSmall && <Box w={10} />}

      <Box flex={3}>
        <Text size="xs">{TransactionListLabels.ACTION}</Text>
      </Box>
      <Box flex={2} {...(onSort ? sortableStyle : {})} onClick={() => onSort?.('amount')}>
        <Text size="xs">{TransactionListLabels.AMOUNT}</Text>
        {onSort && renderSortIcon('amount')}
      </Box>
      {!isScreenSmall && (
        <Box flex={2}>
          <Text size="xs">{TransactionListLabels.TO_TARGET}</Text>
        </Box>
      )}
      <Box flex={2} {...(onSort ? sortableStyle : {})} onClick={() => onSort?.('date')}>
        <Text size="xs">{TransactionListLabels.EXPIRES}</Text>
        {onSort && renderSortIcon('date')}
      </Box>
      {!isScreenSmall && (
        <Box flex={1}>
          <Text size="xs">{TransactionListLabels.THRESHOLD}</Text>
        </Box>
      )}
      {!isScreenSmall && (
        <Box w={130} display="flex" alignItems="center">
          <Text ml="auto" mr="38px" size="xs">
            {TransactionListLabels.STATUS}
          </Text>
        </Box>
      )}
    </Flex>
  );
};

export default TransactionListHeader;
